<template>
  <div
    style=" display: flex; flex-direction: row;"
    :style="
      searchlist[0].name == 'search'
        ? 'height: 48px;'
        : 'min-height: 48px; flex-wrap: wrap; height: auto !important; overflow-y: auto;'
    "
  >
    <v-tab
      color="rgba(255, 255, 255, 1)"
      style="cursor: none; color: #0C2F53; margin:0;  border-radius: 0 !important; min-width: 80%; "
    >
      <!--  display: flex; align-items: center; justify-content: flex-start;  -->
      <div
        v-if="searchlist[0].name == 'search' && !showSearch"
        style="padding-left: 25px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 73%; font-family: 'Sukhumvit'; font-weight: 700 !important; font-size: 16px !important;"
      >
        {{ searchlist[0].value }}
      </div>
      <!-- -if="searchlist[0].name == 'tags' && !showSearch" -->
      <v-flex
        v-else-if="searchlist[0].name == 'tags' && !showSearch"
        style="flex-wrap: wrap; max-width: 100%; display: flex !important; flex-direction: row !important; text-align: left; font-family: 'Sukhumvit'; font-weight: 600 !important; font-size: 16px !important; "
      >
        <div
          v-for="(item, index) in searchlist[0].value"
          :key="index"
          style="max-width: 100%; display: flex; align-items: center; flex-direction: row; border: 1px solid #0C2F53; border-radius: 16px; padding-right: 13px; padding-left: 19px; margin: 5px"
        >
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">
            {{ item }}
          </div>
          <!-- @click="$emit('clearSearch')" -->
          <!-- @click=Onprint -->
          <v-btn
            flat
            @click="$emit('deleteTagNSearch', index)"
            depressed
            color="rgba(255, 255, 255, 1)"
            style="cursor: pointer; font-size: 16px; min-width:5px; border-radius: 0 !important; color: rgba(12, 47, 83, 1); margin-left: 2px;"
            class="ma-0 pa-0"
          >
            <v-icon style="font-size: 16px;">close</v-icon>
          </v-btn>
        </div>
      </v-flex>

      <v-spacer v-if="searchlist[0].name == 'search'"></v-spacer>
    </v-tab>
    <v-btn
      v-if="searchlist[0].name == 'search' && !showSearch"
      @click="$emit('clearSearch')"
      depressed
      color="rgba(255, 255, 255, 1)"
      style="border-radius: 0 !important; min-width: 20%;height: 48px; color: rgba(12, 47, 83, 1);"
      class="ma-0 pa-0"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
export default {
  props: {
    value: {
      default: false
    },
    input: {
      type: String,
      tags: { type: Array }
    },
    tagOptions: {
      type: Array
    },
    showSearch: {
      type: Boolean
    }
  },
  components: {
    Multiselect
  },
  data() {
    return {
      // tagOptions: [],
      // input: {
      //   uuAreaName: '',
      //   search: '',
      //   uu_register_status: '',
      //   lastconversationfromdate: null,
      //   lastconversationtodate: null,
      //   lastconversationfromtime: null,
      //   lastconversationtotime: null,
      //   lastconversationfrom: null,
      //   lastconversationto: null,
      //   phoneno: null,
      //   uu_name: null,
      //   keyword: '',
      //   tags: [],
      //   status: null,
      //   app: '',
      //   session: '',
      //   assignadminname: '',
      //   realname: '',
      //   cardnumber: '',
      // },
      // openStartDate: false,
      // openEndDate: false,
      // openStartTime: false,
      // openEndTime: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      searchlist: 'getLivechatSearching'
    }),
    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    }
  },
  methods: {
    Onprint() {
      console.log(this.searchlist)
    }
  }
  // methods: {
  //   clearSearch() {
  //     this.input = {
  //       uuAreaName: '',
  //       search: '',
  //       uu_register_status: '',
  //       lastconversationfromdate: null,
  //       lastconversationtodate: null,
  //       lastconversationfromtime: null,
  //       lastconversationtotime: null,
  //       lastconversationfrom: null,
  //       lastconversationto: null,
  //       phoneno: null,
  //       uu_name: null,
  //       keyword: '',
  //       tags: [],
  //       status: null,
  //       app: '',
  //       realname: '',
  //       cardnumber: '',
  //     }
  //     this.onSearch()
  //   },
  //   onSearch() {
  //     let vm = this
  //     if (vm.input.lastconversationfromdate) {
  //       vm.input['lastconversationfrom'] =
  //         vm.input.lastconversationfromdate +
  //         (vm.input.lastconversationfromtime ? ' ' + vm.input.lastconversationfromtime : ' 00:00')
  //     } else {
  //       vm.input['lastconversationfrom'] = null
  //     }

  //     if (vm.input.lastconversationtodate) {
  //       vm.input['lastconversationto'] =
  //         vm.input.lastconversationtodate +
  //         (vm.input.lastconversationtotime ? ' ' + vm.input.lastconversationtotime : ' 23:59')
  //     } else {
  //       vm.input['lastconversationto'] = null
  //     }

  //     vm.$store.commit('SET_LIVECHAT_FILTER', vm.input)

  //     vm.usersearching = true
  //     vm.$nextTick(() => {
  //       vm.$store.dispatch('forceLoadLastestUsers').then(() => {
  //         vm.usersearching = false
  //       })
  //       vm.$emit('input', false)
  //     })
  //   },
  //   addTag(newTag) {
  //     const tag = newTag
  //     this.tagOptions.push(tag)
  //     this.input.tags.push(tag)
  //   },
  // },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatSearchBox.vue